import { useQuery } from '@tanstack/react-query';
import toastMsg from '../../../lib/toastMsg';
import { extractErrorMessage } from '../../../lib/utils/checkErrorResponse';
import { useNavigate } from 'react-router-dom';
import { AccountSellerApiV2 } from '../../../lib/api/account/seller/AccountSellerApiV2';

const useSellersQuery = (payload) => {
  const navigate = useNavigate();
  return useQuery(['sellers', payload], () => AccountSellerApiV2.fetchSellers(payload), {
    onError: (error) => {
      toastMsg.error(extractErrorMessage(error));
      navigate('/account/seller/list?pageIndex=1&pageSize=100&sort=-id');
    },
    keepPreviousData: true,
  });
};

export default useSellersQuery;
